export default (theme) => ({
  root: {
    backgroundColor: '#FAFBFC',
    borderRadius: 0,
    display: 'flex',
    flexWrap: 'wrap',
    padding: 24,
    borderBottom: '1px solid #E1E9F0',
  },

  box: {
    ...theme.box,
    margin: 16,
    padding: '16px 10px',
    position: 'relative',
    minWidth: 280,
    maxWidth: 400,
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    flex: 1,
  },

  boxSummary: {
    background: '#F7F8FF',
    boxShadow: '0 1px 2px 0 rgba(0,0,0,0.08)',
    fontSize: 15,
    color: '#FFFFFF',
    minHeight: 180,
  },

  warning: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: 13,
    lineHeight: '16px',
    fontWeight: 500,

    '& > svg': {
      marginBottom: 8,
    },

    '& a': {
      color: 'inherit',
      textDecoration: 'underline',
    },
  },

  contactAudienceSummary: {
    backgroundImage:
      'linear-gradient(to bottom right, #7793FF 0%, #D576F0 100%)',
  },

  prospectAudienceSummary: {
    backgroundImage:
      'linear-gradient(to bottom right, #7793FF 0%, #1877F2 100%)',
  },

  visitorAudienceSummary: {
    backgroundImage:
      'linear-gradient(to bottom right, #80DFFD 0%, #3ABEFA 100%)',
  },

  lastSyncBox: {
    ...theme.box,
    margin: 16,
    minWidth: 280,
    maxWidth: 400,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },

  boxHeader: {
    padding: '16px 24px 16px',
    borderBottom: '1px solid #E1E9F0',
    display: 'flex',
    maxWidth: '100%',
    flexDirection: 'row',
  },

  serviceIcon: {
    flex: '0 0 auto',
    margin: '0 12px 0 0',
  },

  externalInfo: {
    ...theme.ellipsis,
    flex: '0 1 auto',
    display: 'flex',
    maxWidth: '100%',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  externalName: {
    fontSize: 15,
    fontWeight: 500,
    overflowWrap: 'break-word',
    ...theme.ellipsis,
  },

  externalAccount: {
    display: 'flex',
    color: '#9BADBC',
    fontSize: 13,
    fontWeight: 400,
  },

  middot: {
    padding: '0 4px',
  },

  status: {
    fontSize: 15,
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      marginRight: 8,
    },
  },

  statusSuccess: {
    color: theme.palette.text.success,
  },

  boxContents: {
    display: 'flex',
    flexDirection: 'column',
    background: '#FAFBFC',
    color: '#7B8B99',
    marginBottom: 0,
    flexGrow: 1,
    padding: '16px 24px',
    fontSize: 14,
    overflow: 'hidden',
    borderRadius: '0 0 6px 6px',
  },

  totalMatches: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 1 auto',

    '& strong': {
      fontWeight: 600,
      fontSize: 60,
      color: '#FFFFFF',
      letterSpacing: '-2px',
      textAlign: 'center',
      lineHeight: '62px',
    },
  },

  matchesSummary: {
    opacity: 0.6,
  },

  peopleImage: {
    position: 'absolute',
    left: 0,
    top: 16,
  },

  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 16,
    marginTop: 16,
    width: '100%',
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
  },

  healthIndicator: {
    marginRight: '8px',
  },

  latestSync: {
    flexGrow: 1,
  },

  nextSearchAt: {
    marginTop: 12,
    justifySelf: 'flex-end',
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      marginRight: 8,
    },
  },
});
